import gql from 'graphql-tag'
import graphql from 'utils/graphql'
import {
    UpdateMeetingSpaceMutation,
    UpdateMeetingSpaceMutationVariables,
    CreateMeetingMutation,
    CreateMeetingMutationVariables,
    UpdateMeetingMutation,
    UpdateMeetingMutationVariables,
    DeleteMeetingMutation,
    DeleteMeetingMutationVariables,
    AddParticipantMutation,
    AddParticipantMutationVariables,
    RemoveParticipantMutation,
    RemoveParticipantMutationVariables,
    UpdateRoleMutation,
    UpdateRoleMutationVariables,
    ImportMeetingMutation,
    ImportMeetingMutationVariables,
    ImportMeetingParticipantsMutation,
    ImportMeetingParticipantsMutationVariables
} from '../../../generated/graphql'

const updateMeetingSpaceMutation = gql`
    mutation updateMeetingSpace($id: ID!, $data: UpdateMeetingSpace!) {
        updateMeetingSpace(id: $id, data: $data) {
            id
            parent {
                image
            }
        }
    }
`
export const updateMeetingSpace = (id, data: UpdateMeetingSpaceMutationVariables['data']) => {
    const mutation = graphql.createQuery<
        UpdateMeetingSpaceMutation, UpdateMeetingSpaceMutationVariables
    >(updateMeetingSpaceMutation)
    return mutation({ id, data })
}

const createMeetingMutation = gql`
    mutation createMeeting($data: CreateMeeting!) {
        createMeeting(data: $data) {
            id
        }
    }
`
export const createMeeting = (data: CreateMeetingMutationVariables['data']) => {
    const mutation = graphql.createQuery<
        CreateMeetingMutation, CreateMeetingMutationVariables
    >(createMeetingMutation)
    return mutation({ data })
}

const updateMeetingMutation = gql`
    mutation updateMeeting($id: ID!, $data: UpdateMeeting!) {
        updateMeeting(id: $id, data: $data) {
            id
        }
    }
`
export const updateMeeting = (id, data: UpdateMeetingMutationVariables['data']) => {
    const mutation = graphql.createQuery<
        UpdateMeetingMutation, UpdateMeetingMutationVariables
    >(updateMeetingMutation)
    return mutation({ id, data })
}

const deleteMeetingMutation = gql`
    mutation deleteMeeting($id: ID!) {
        deleteMeeting(id: $id)
    }
`
export const deleteMeeting = (id) => {
    const mutation = graphql.createQuery<
        DeleteMeetingMutation, DeleteMeetingMutationVariables
    >(deleteMeetingMutation)
    return mutation({ id })
}

const addParticipantMutation = gql`
    mutation addParticipant($data: AddMeetingUser!) {
        addMeetingUser(data: $data) {
            id
        }
    }
`
export const addMeetingParticipant = (data: AddParticipantMutationVariables['data']) => (
    graphql.createQuery<
        AddParticipantMutation, AddParticipantMutationVariables
    >(addParticipantMutation)({ data })
)

const deleteParticipant = gql`
    mutation removeParticipant($id: ID!) {
        removeMeetingUser(id: $id)
    }
`
export const removeMeetingParticipant = (id) => (
    graphql.createQuery<
        RemoveParticipantMutation, RemoveParticipantMutationVariables
    >(deleteParticipant)({ id })
)

const updateRoleMutation = gql`
    mutation updateRole($id: ID!, $data: UpdateMeetingUser!) {
        updateMeetingUser(id: $id, data: $data) {
            id,
            role
        }
    }
`
export const updateRole = (id, role) => (
    graphql.createQuery<
        UpdateRoleMutation, UpdateRoleMutationVariables
    >(updateRoleMutation)({ id, data: { role } })
)

const importMeetingMutation = gql`
    mutation importMeeting($meetingSpace: ID!, $data: [ImportMeeting!]!) {
        importMeeting(meetingSpace: $meetingSpace, data: $data) {
            successCount
            errorCount
            errorItems {
                id
                message
                hiddenMessage
            }
        }
    }
`
export const importMeetings = ({ meetingSpace, data }) => (
    graphql.createQuery<
        ImportMeetingMutation, ImportMeetingMutationVariables
    >(importMeetingMutation)({ meetingSpace, data })
)

const importMeetingParticipantsMutation = gql`
    mutation importMeetingParticipants($meetingSpace: ID!, $data: [ImportMeetingParticipant!]!) {
        importMeetingParticipants(meetingSpace: $meetingSpace, data: $data) {
            successCount
            errorCount
            errorItems {
                id
                message
                hiddenMessage
            }
        }
    }
`
export const importMeetingParticipants = ({ meetingSpace, data }) => (
    graphql.createQuery<
        ImportMeetingParticipantsMutation, ImportMeetingParticipantsMutationVariables
    >(importMeetingParticipantsMutation)({ meetingSpace, data })
)
